import CartaId from '../../entities/CartaId';
import SubmitPortOpeningObjectOnPrem from './SubmitPortOpeningObjectOnPrem';

export default class SubmitPORequestObjectOnPrem {

	type!: string

	onPremObjects!: SubmitPortOpeningObjectOnPrem[];

	direction!: string;
	
	contactId!: string;

	justification!: string;

	comments!: string;

	projectId!: string;

	approverId!: string;

	OnPremObjectRequestId!: number;

	cartaId!: CartaId[];

    firewall!: string; //Firewall

	firewallEnvironment!: string;

	siteCoordination!: boolean;

	trackerID!: number;

	appEndorserId!: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}